// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"99f74c6d","453":"2f8eb9a3"}[chunkId] + ".chunk.js";
};